/**
 * @generated SignedSource<<1f0196f4727aa9d0ce9149df124c8a65>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PipelineRunHeaderFragment$data = {
  readonly rawId: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"pipelineHeadFragment">;
  readonly " $fragmentType": "PipelineRunHeaderFragment";
};
export type PipelineRunHeaderFragment$key = {
  readonly " $data"?: PipelineRunHeaderFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PipelineRunHeaderFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PipelineRunHeaderFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rawId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "pipelineHeadFragment"
    }
  ],
  "type": "ProjectRest",
  "abstractKey": null
};

(node as any).hash = "54b3757b0067bc8bcfe38c7a38fd11d3";

export default node;
